<script>

    import { toast } from 'bulma-toast'
    import { priceStore, pricesStore, modalStore, adminStore } from '../stores'

    import { isPermission } from '../$methods/permissions.methods'

    import PricesService from '../$services/prices.service'
    import DateMethods from '../$methods/date.methods'
    import NumeralMethods from '../$methods/numeral.methods'
    import TranslateMethods from '../$methods/translate.methods'

    import ButtonDelete from '../$components/button.delete.svelte'
    import Button from '../$components/button.svelte'
    import InfoCard from '../$components/info.card.svelte'
    import InfoField from '../$components/info.field.svelte'

    let loading = false

    async function deletePrice() {

        loading = true
        const resp = await PricesService.deletePrice($priceStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        pricesStore.remove($priceStore._id)
        modalStore.close()
    }

    function getValor(price) {
        if(price.pricing === 'price')
            return NumeralMethods.cash(price.value)
        if(price.pricing === 'percent')
            return `${ price.value }%`
        if(price.pricing === 'amount')
            return NumeralMethods.cash(price.value)
        return price.value
    }

</script>

<InfoCard subtitle="Precio">
    <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
        {#if $priceStore.user}
            <InfoField label="Usuario" icon="fas fa-user" value={ $priceStore.user.name } bold />
            <InfoField label="Correo" icon="fas fa-envelope" value={ $priceStore.user.email } />
        {/if}
        <InfoField label="Tipo de precio" icon="fas fa-tags" value={ TranslateMethods.get($priceStore.type) } />
        <InfoField label="Proveedor" icon="fas fa-truck" value={ $priceStore.provider } />
        <InfoField label="Servicio" icon="fas fa-box" value={ $priceStore.service } />
        <InfoField label="Peso mínimo" icon="fas fa-weight" value="{ $priceStore.volumetricMin } KG" />
        <InfoField label="Peso máximo" icon="fas fa-weight-hanging" value="{ $priceStore.volumetricMax } KG" />
        <InfoField label="Tipo" icon="fas fa-tag" value={ TranslateMethods.get($priceStore.pricing) } />
        <InfoField label="Valor" icon="fas fa-dollar-sign" value={ getValor($priceStore) } />
        {#if $priceStore.type === 'user'}
            <InfoField label="Fecha de expiración" icon="far fa-calendar-times" value={ DateMethods.dateTimeLarge($priceStore.expired) } />
        {/if}
        <InfoField label="Fecha de creación" icon="far fa-calendar-alt" value={ DateMethods.dateTimeLarge($priceStore.created) } />
        {#if $priceStore.admin}
            <InfoField label="Admin" icon="fas fa-user-shield" value={ $priceStore.admin.name } />
            <InfoField label="Correo admin" icon="fas fa-envelope" value={ $priceStore.admin.email } />
        {/if}
    </div>
</InfoCard>

<div class="items-end">
    <div class="buttons">
        {#if isPermission($adminStore, 'UsersView.Price.Delete')}
            <ButtonDelete on:confirm={deletePrice} {loading} />
        {/if}
        {#if isPermission($adminStore, 'UsersView.Price.Update')}
            <Button on:click={() => modalStore.set('price_update_modal')} text="Actualizar" icon="edit" color="primary" />
        {/if}
    </div>
</div>
